import React, { useEffect } from "react";
import { openDemoModal } from "../utils/demoModal";
import CookieBanner from "./CookieBanner";
import heroMark from "../assets/assets/logos/Viriqio_hires_favicon.png";

const ABOUT_PAGE_STYLES = `

.about-page{
  --purple:#6A1B9A;--violet:#00AEEF;--ink:#0B1F44;--lilac:#F5F8FF;
  --ink-2:#4B5563;--ink-3:#6B7280;--line:#E3E7EE;
  --radius:20px;--ease:cubic-bezier(.22,1,.36,1);--wrap:1200px;--pad:clamp(76px,9vw,120px);
}
.about-page,.about-page *,.about-page *::before,.about-page *::after{box-sizing:border-box}
.about-page *{margin:0;padding:0}
html{scroll-behavior:smooth;scroll-padding-top:90px}
.about-page{font-family:'Inter',system-ui,-apple-system,sans-serif;color:var(--ink);background:#fff;line-height:1.6;text-align:left;-webkit-font-smoothing:antialiased;overflow-x:clip}
.about-page img{max-width:100%;display:block}
.about-page a{color:inherit;text-decoration:none}
.about-page .wrap{width:100%;max-width:var(--wrap);margin:0 auto;padding:0 24px}
.about-page section{padding:var(--pad) 0;position:relative}

.about-page .eyebrow{display:inline-flex;align-items:center;gap:10px;font-size:13px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--purple)}
.about-page .eyebrow::before{content:"";width:22px;height:2px;border-radius:2px;background:linear-gradient(90deg,var(--purple),var(--violet))}
.about-page h1,.about-page h2,.about-page h3{letter-spacing:-.025em;line-height:1.12;color:var(--ink)}
.about-page h1{font-size:clamp(40px,5.6vw,68px);font-weight:800}
.about-page h2{font-size:clamp(32px,4.2vw,52px);font-weight:700;margin-top:18px}
.about-page h3{font-size:20px;font-weight:600;letter-spacing:-.01em}
.about-page .lead{font-size:clamp(17px,1.5vw,20px);color:var(--ink-2);max-width:620px;margin-top:22px}
.about-page .center{text-align:center}
.about-page .center .lead{margin-left:auto;margin-right:auto}
.about-page .grad{background:linear-gradient(100deg,#00AEEF 0%,#6A1B9A 100%);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent}
.about-page .sec-head{max-width:760px;margin-bottom:clamp(44px,5vw,68px)}
.about-page .sec-head.center{margin-left:auto;margin-right:auto}

.about-page .btn{display:inline-flex;align-items:center;gap:10px;height:54px;padding:0 28px;border-radius:999px;font-weight:600;font-size:16px;transition:transform .35s var(--ease),box-shadow .35s var(--ease),background .3s;cursor:pointer;border:0;position:relative;overflow:hidden;white-space:nowrap}
.about-page .btn-primary{background:linear-gradient(125deg,#00AEEF 0%,#3A5BC7 45%,#6A1B9A 90%);color:#fff;box-shadow:0 10px 30px -10px rgba(106,27,154,.45)}
.about-page .btn-primary::after{content:"";position:absolute;inset:0;background:linear-gradient(110deg,transparent 30%,rgba(255,255,255,.35) 50%,transparent 70%);transform:translateX(-120%);transition:transform .8s var(--ease)}
.about-page .btn-primary:hover::after{transform:translateX(120%)}
.about-page .btn-primary:hover{background:linear-gradient(125deg,#00AEEF 0%,#3A4AB0 45%,#4A1270 90%);transform:translateY(-2px);box-shadow:0 18px 40px -12px rgba(106,27,154,.55)}
.about-page .btn .arr{transition:transform .35s var(--ease)}
.about-page .btn:hover .arr{transform:translateX(4px)}

/* ---------- nav ---------- */
.nav{position:fixed;inset:0 0 auto 0;z-index:50;background:#fff;border-bottom:1px solid #E5E7EB;transition:box-shadow .3s}
.nav.scrolled{box-shadow:0 6px 24px -12px rgba(25,31,45,.18)}
.nav-wrap,.foot-wrap{max-width:1338px;margin:0 auto;padding:0 24px}
.nav-wrap{height:80px;display:flex;align-items:center;justify-content:space-between;gap:24px}
.nav .logo img{height:46px;width:auto}
.nav-links{display:flex;align-items:center;gap:6px;list-style:none}
.nav-links>li{position:relative}
.nav-links>li>a,.nav-links>li>button{display:inline-flex;align-items:center;gap:6px;padding:8px 10px;border-radius:6px;font:400 16px/1.2 'Inter',sans-serif;color:var(--ink);background:none;border:0;cursor:pointer;transition:background .2s,color .2s}
.nav-links>li>a:hover,.nav-links>li>button:hover,.nav-links .has-dd.open>button,.nav-links .has-dd:hover>button{background:var(--lilac);color:var(--purple)}
.nav-links .dd-trigger{background:var(--lilac)}
.nav-links .chev{width:12px;height:12px;transition:transform .25s}
.has-dd:hover .chev,.has-dd.open .chev{transform:rotate(180deg)}
.dd{position:absolute;top:calc(100% + 8px);left:0;min-width:200px;background:#fff;border:1px solid #E5E7EB;border-radius:10px;box-shadow:0 18px 40px -16px rgba(25,31,45,.25);padding:8px;list-style:none;opacity:0;visibility:hidden;transform:translateY(6px);transition:opacity .2s,transform .2s,visibility .2s}
.has-dd::after{content:"";position:absolute;left:0;right:0;top:100%;height:10px}
.has-dd:hover .dd,.has-dd.open .dd{opacity:1;visibility:visible;transform:none}
.dd a{display:block;padding:9px 12px;border-radius:6px;font-size:15px;color:var(--ink-2)}
.dd a:hover{background:var(--lilac);color:var(--purple)}
.nav-actions{display:flex;align-items:center;gap:16px}
.nav-search{width:40px;height:40px;display:grid;place-items:center;border:0;background:none;color:var(--ink);cursor:pointer;border-radius:8px}
.nav-search:hover{background:var(--lilac)}
.nav-search svg{width:22px;height:22px}
.nbtn{display:inline-flex;align-items:center;justify-content:center;height:40px;padding:0 28px;border-radius:6px;font-size:15px;font-weight:500;white-space:nowrap;transition:background .2s,color .2s,box-shadow .2s}
.nbtn-outline{border:1px solid var(--purple);color:var(--ink);background:#fff}
.nbtn-outline:hover{background:var(--lilac)}
.nbtn-solid{background:var(--purple);color:#fff;font-weight:600;font-size:14px;padding:0 18px;border:1px solid var(--purple)}
.nbtn-solid:hover{background:#4A1270;box-shadow:0 10px 24px -12px rgba(106,27,154,.55)}
.nav-toggle{display:none;width:40px;height:40px;border:0;background:none;cursor:pointer;color:var(--ink)}
.nav-toggle svg{width:24px;height:24px}
@media(max-width:1060px){
  .nav-toggle{display:grid;place-items:center}
  .nav-menu{position:absolute;top:80px;left:0;right:0;background:#fff;border-bottom:1px solid #E5E7EB;box-shadow:0 18px 30px -20px rgba(25,31,45,.3);display:none;padding:12px 24px 20px}
  .nav.menu-open .nav-menu{display:block}
  .nav-links{flex-direction:column;align-items:stretch;gap:2px}
  .nav-links>li>a,.nav-links>li>button{width:100%;justify-content:space-between;padding:12px}
  .nav-links .dd-trigger{background:none}
  .dd{position:static;opacity:1;visibility:visible;transform:none;box-shadow:none;border:0;display:none;padding:0 0 0 12px}
  .has-dd.open .dd{display:block}
  .has-dd::after{display:none}
}
@media(max-width:600px){.nav-wrap{height:68px;gap:12px}.nav-menu{top:68px!important}.nav .logo img{height:32px}.nbtn-outline{display:none}.nav-actions{gap:8px}.nbtn-solid{padding:0 14px;font-size:14px}}
.nav-links .m-login{display:none}
@media(max-width:600px){.nav-links .m-login{display:block;margin-top:8px;border-top:1px solid #E5E7EB;padding-top:8px}.nav-links .m-login a{color:var(--purple);font-weight:500}}
@media(max-width:400px){.nav-search{display:none}}
.nav-links>li>a.active{color:var(--purple);font-weight:500}

/* reveal */
.rv{opacity:0;transform:translateY(36px);transition:opacity 1s var(--ease),transform 1s var(--ease)}
.rv.in{opacity:1;transform:none}
.stagger>*{opacity:0;transform:translateY(36px);transition:opacity .9s var(--ease),transform .9s var(--ease)}
.stagger.in>*{opacity:1;transform:none}
.stagger.in>*:nth-child(2){transition-delay:.12s}
.stagger.in>*:nth-child(3){transition-delay:.24s}
.stagger.in>*:nth-child(4){transition-delay:.36s}
.stagger.in>*:nth-child(5){transition-delay:.48s}
.fade-in{opacity:0;animation:rise 1s var(--ease) forwards}
@keyframes rise{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:none}}
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes bob{50%{transform:translateY(-10px)}}
@keyframes pulse{0%{transform:scale(.9);opacity:1}100%{transform:scale(1.7);opacity:0}}

.ic{width:56px;height:56px;border-radius:16px;background:var(--lilac);display:grid;place-items:center;color:var(--purple);transition:background .4s,color .4s,transform .5s var(--ease)}
.ic svg{width:26px;height:26px}

/* ---------- hero ---------- */
.about-page .hero{padding:clamp(128px,11vw,158px) 0 clamp(76px,8vw,108px);overflow:hidden;background:radial-gradient(1000px 560px at 85% 0%,#F5F8FF 0%,rgba(245,248,255,0) 60%),#fff}
.hero-grid{display:grid;grid-template-columns:minmax(0,1.1fr) minmax(0,.9fr);gap:clamp(36px,5vw,72px);align-items:center}
.hero-grid>div,.purpose-grid>div,.serve-grid>div{min-width:0}
.hero h1{margin-top:22px}
.hero .btn{margin-top:44px}
.pills{display:flex;gap:12px;flex-wrap:wrap;margin-top:52px}
.pill{display:inline-flex;align-items:center;gap:10px;padding:10px 18px;border-radius:999px;background:#fff;border:1px solid var(--line);font-size:14px;font-weight:500;color:var(--ink-2)}
.pill svg{width:16px;height:16px;color:var(--violet)}
/* orbit visual */
.orbit-wrap{position:relative;width:100%;max-width:480px;aspect-ratio:1;margin:0 auto}
.orbit-wrap .ring{position:absolute;border-radius:50%;border:1.5px dashed rgba(0,174,239,.4)}
.orbit-wrap .ring.r1{inset:0;animation:spin 40s linear infinite}
.orbit-wrap .ring.r2{inset:17%;border-style:solid;border-color:rgba(106,27,154,.1)}
.orbit-wrap .glow{position:absolute;inset:25%;border-radius:50%;background:radial-gradient(closest-side,rgba(0,174,239,.45),transparent);filter:blur(20px);animation:bob 6s ease-in-out infinite}
.orbit-wrap .mark{position:absolute;inset:31%;border-radius:32%;overflow:hidden;box-shadow:0 30px 70px -25px rgba(106,27,154,.6);animation:bob 6s ease-in-out infinite}
.orbit-wrap .mark img{width:100%;height:100%}
.orbit-wrap .mark::after{content:"";position:absolute;inset:0;background:linear-gradient(115deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:sheen 4.5s var(--ease) infinite}
@keyframes sheen{60%,100%{transform:translateX(100%)}}
.spinner{position:absolute;inset:0;animation:spin 36s linear infinite}
.chip{position:absolute;transform:translate(-50%,-50%)}
.chip span{display:flex;align-items:center;gap:8px;padding:10px 16px;border-radius:999px;background:#fff;border:1px solid var(--line);box-shadow:0 14px 30px -16px rgba(106,27,154,.4);font-size:14px;font-weight:600;white-space:nowrap;animation:spin 36s linear infinite reverse}
.chip span i{width:8px;height:8px;border-radius:50%;background:var(--violet)}
@media(max-width:960px){.hero-grid{grid-template-columns:1fr}.orbit-wrap{max-width:360px}}
@media(max-width:600px){.orbit-wrap{width:calc(100% - 110px)}}
@media(max-width:420px){.chip span{font-size:12px;padding:8px 12px}}

/* ---------- purpose ---------- */
.purpose{background:var(--lilac);border-radius:48px;margin:0 16px}
.purpose-grid{display:grid;grid-template-columns:.8fr 1.2fr;gap:clamp(48px,7vw,110px);align-items:start}
.reveal-text{font-size:clamp(22px,2.4vw,30px);line-height:1.5;font-weight:500;letter-spacing:-.01em}
.reveal-text span{color:rgba(25,31,45,.18);transition:color .4s}
.reveal-text span.on{color:var(--ink)}
.purpose .note{margin-top:40px;display:flex;align-items:center;gap:16px;padding:22px 26px;border-radius:18px;background:#fff;font-weight:600;font-size:17px}
.purpose .note .ic{width:44px;height:44px;border-radius:12px;flex:none}
.purpose .note .ic svg{width:22px;height:22px}
@media(max-width:900px){.purpose-grid{grid-template-columns:1fr}}

/* ---------- building ---------- */
.flow{position:relative;display:grid;grid-template-columns:repeat(4,1fr);gap:24px}
.flow .track{position:absolute;top:52px;left:12.5%;right:12.5%;height:2px;background:var(--line)}
.flow .track b{position:absolute;inset:0;background:linear-gradient(90deg,var(--purple),var(--violet));transform:scaleX(0);transform-origin:left;transition:transform 2s var(--ease) .3s}
.flow.in .track b{transform:scaleX(1)}
.flow .track i{position:absolute;top:50%;left:0;width:10px;height:10px;margin:-5px 0 0 -5px;border-radius:50%;background:var(--violet);box-shadow:0 0 14px 4px rgba(0,174,239,.55);opacity:0}
.flow.in .track i{animation:travel 3.6s var(--ease) 2.3s infinite}
@keyframes travel{0%{left:0;opacity:0}10%{opacity:1}90%{opacity:1}100%{left:100%;opacity:0}}
.node{text-align:center;padding:0 8px}
.node .bubble{position:relative;width:104px;height:104px;margin:0 auto 32px;border-radius:50%;background:#fff;border:1px solid var(--line);display:grid;place-items:center;color:var(--purple);box-shadow:0 20px 50px -28px rgba(106,27,154,.5);transition:transform .5s var(--ease),background .5s,color .5s}
.node .bubble svg{width:36px;height:36px}
.node .bubble em{position:absolute;top:-6px;right:-6px;font-style:normal;font-size:12px;font-weight:700;background:var(--purple);color:#fff;border-radius:999px;padding:4px 9px}
.node:hover .bubble{transform:translateY(-6px);background:var(--purple);color:#fff}
.node p{color:var(--ink-2);margin-top:10px;font-size:16px;max-width:240px;margin-left:auto;margin-right:auto}
.callout{margin-top:clamp(64px,8vw,96px);border-radius:24px;padding:30px 36px;display:flex;align-items:center;justify-content:center;gap:18px;flex-wrap:wrap;text-align:center;background:linear-gradient(125deg,#00AEEF 0%,#3A5BC7 45%,#6A1B9A 90%);color:#fff;font-size:clamp(18px,1.8vw,22px);font-weight:600;position:relative;overflow:hidden}
.callout::before{content:"";position:absolute;inset:0;background:linear-gradient(110deg,transparent 35%,rgba(255,255,255,.18) 50%,transparent 65%);transform:translateX(-100%);animation:sheen 6s var(--ease) infinite}
.callout svg{width:28px;height:28px;flex:none}
@media(max-width:900px){.flow{grid-template-columns:1fr 1fr;row-gap:56px}.flow .track{display:none}}
@media(max-width:520px){.flow{grid-template-columns:1fr}}

/* ---------- approach ---------- */
.about-page .approach{padding-top:0}
.ap-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.ap{position:relative;padding:48px 38px 52px;border-radius:24px;background:#fff;border:1px solid var(--line);overflow:hidden;transition:transform .5s var(--ease),box-shadow .5s,border-color .5s}
.ap::before{content:"";position:absolute;inset:0;background:radial-gradient(420px circle at var(--mx,50%) var(--my,0%),rgba(0,174,239,.14),transparent 45%);opacity:0;transition:opacity .4s}
.ap:hover{transform:translateY(-8px);box-shadow:0 30px 60px -30px rgba(106,27,154,.3);border-color:rgba(0,174,239,.45)}
.ap:hover::before{opacity:1}
.ap:hover .ic{background:var(--purple);color:#fff;transform:rotate(-6deg)}
.ap .ic{margin-bottom:36px}
.ap .big{position:absolute;right:24px;top:18px;font-size:72px;font-weight:800;letter-spacing:-.04em;color:var(--lilac);line-height:1;transition:color .5s}
.ap:hover .big{color:#E9D8FF}
.ap p{color:var(--ink-2);margin-top:12px}
@media(max-width:900px){.ap-grid{grid-template-columns:1fr}}

/* ---------- who we serve ---------- */
.serve{background:var(--lilac);border-radius:48px;margin:0 16px}
.serve-grid{display:grid;grid-template-columns:.9fr 1.1fr;gap:clamp(48px,7vw,110px);align-items:start}
.serve-grid .sec-head{position:sticky;top:140px;margin-bottom:0}
.who{display:flex;align-items:center;gap:28px;padding:34px 32px;border-radius:22px;background:#fff;margin-bottom:18px;transition:transform .5s var(--ease),box-shadow .5s}
.who:last-child{margin-bottom:0}
.who:hover{transform:translateX(8px);box-shadow:0 24px 50px -30px rgba(106,27,154,.4)}
.who .ic{flex:none}
.who:hover .ic{background:var(--purple);color:#fff}
.who div p{color:var(--ink-2);margin-top:6px}
.who .go{margin-left:auto;flex:none;width:40px;height:40px;border-radius:50%;border:1.5px solid var(--line);display:grid;place-items:center;color:var(--purple);transition:all .4s var(--ease)}
.who:hover .go{background:var(--purple);border-color:var(--purple);color:#fff;transform:rotate(-45deg)}
@media(max-width:900px){.serve-grid{grid-template-columns:1fr}.serve-grid .sec-head{position:static}}
@media(max-width:520px){.who{padding:28px 22px;gap:18px}.who .go{display:none}}

/* ---------- philosophy ---------- */
.philo{background:linear-gradient(135deg,#0B1F44 0%,#0B1F44 45%,#0A4F86 100%);color:#fff;border-radius:48px;margin:var(--pad) 16px 0;overflow:hidden}
.philo h2{color:#fff;max-width:880px}
.philo .eyebrow{color:var(--violet)}
.philo-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px;margin-top:clamp(64px,8vw,96px)}
.pp{padding:40px 34px;border-radius:24px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);transition:background .5s,border-color .5s,transform .5s var(--ease)}
.pp:hover{background:rgba(0,174,239,.1);border-color:rgba(0,174,239,.4);transform:translateY(-6px)}
.pp .k{font-size:clamp(28px,2.8vw,38px);font-weight:800;letter-spacing:-.03em;background:linear-gradient(100deg,#fff 20%,var(--violet));-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent}
.pp .bar{height:3px;border-radius:3px;background:rgba(255,255,255,.1);margin:22px 0;overflow:hidden}
.pp .bar b{display:block;height:100%;width:0;background:linear-gradient(90deg,var(--violet),#fff);transition:width 1.6s var(--ease)}
.philo-grid.in .pp:nth-child(1) .bar b{width:100%;transition-delay:.3s}
.philo-grid.in .pp:nth-child(2) .bar b{width:100%;transition-delay:.7s}
.philo-grid.in .pp:nth-child(3) .bar b{width:100%;transition-delay:1.1s}
.pp p{color:rgba(255,255,255,.7)}
.tagline{margin-top:clamp(64px,8vw,96px);overflow:hidden;border-top:1px solid rgba(255,255,255,.1);padding-top:40px;-webkit-mask-image:linear-gradient(90deg,transparent,#000 10%,#000 90%,transparent);mask-image:linear-gradient(90deg,transparent,#000 10%,#000 90%,transparent)}
.tagline .t{display:flex;gap:56px;width:max-content;animation:scroll 30s linear infinite}
.tagline span{font-size:clamp(32px,4vw,56px);font-weight:800;letter-spacing:-.03em;white-space:nowrap;color:transparent;-webkit-text-stroke:1.2px rgba(255,255,255,.35)}
.tagline span:nth-child(odd){color:#fff;-webkit-text-stroke:0}
.tagline span.dot{color:var(--violet);-webkit-text-stroke:0}
@keyframes scroll{to{transform:translateX(-50%)}}
@media(max-width:900px){.philo-grid{grid-template-columns:1fr}}

/* ---------- CTA ---------- */
.cta-inner{border-radius:40px;padding:clamp(72px,9vw,120px) clamp(28px,6vw,90px);background:linear-gradient(125deg,#00AEEF 0%,#3A5BC7 45%,#6A1B9A 90%);color:#fff;position:relative;overflow:hidden;text-align:center}
.cta-inner .eyebrow{color:#E9D8FF}.cta-inner .eyebrow::before{background:#E9D8FF}
.cta-inner h2{color:#fff;max-width:820px;margin-left:auto;margin-right:auto}
.cta-inner .lead{color:rgba(255,255,255,.82);margin-left:auto;margin-right:auto}
.cta-inner .btn{margin-top:44px;background:#fff;color:var(--purple);box-shadow:0 14px 30px -12px rgba(0,0,0,.35)}
.cta-inner .btn::after{background:linear-gradient(110deg,transparent 30%,rgba(0,174,239,.25) 50%,transparent 70%)}
.cta-inner .ring{position:absolute;border-radius:50%;border:1px solid rgba(255,255,255,.18);animation:spin 40s linear infinite}
.cta-inner .ring.r1{width:560px;height:560px;left:-180px;bottom:-280px;border-style:dashed}
.cta-inner .ring.r2{width:420px;height:420px;right:-140px;top:-180px;animation-direction:reverse}
.cta-inner .wrapc{position:relative;z-index:2}

/* ---------- footer ---------- */
footer{background:#fff;border-top:1px solid var(--ink);padding:64px 0 36px;color:#5B6478}
.f-top{display:grid;grid-template-columns:minmax(0,1fr) repeat(4,minmax(0,182px));column-gap:40px;row-gap:40px;padding-bottom:48px;border-bottom:1px solid #A3A3A3}
.f-brand img{height:26px;width:auto;margin-bottom:22px}
.f-brand p{font-size:13px;color:#5B6478;margin-bottom:18px}
.f-social{display:flex;gap:12px}
.f-social a{width:32px;height:32px;border-radius:50%;background:var(--purple);color:#fff;display:grid;place-items:center;transition:background .2s,transform .2s}
.f-social a:hover{background:#4A1270;transform:translateY(-2px)}
.f-social svg{width:15px;height:15px;fill:currentColor}
.f-top h5{color:var(--ink);font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;margin:0 0 10px;line-height:1.3}
.f-top ul{list-style:none;display:grid;gap:6px;font-size:13px;line-height:1.4}
.f-top ul a{color:#5B6478;transition:color .2s}
.f-top ul a:hover{color:var(--purple)}
.f-news{margin-top:24px;max-width:320px}
.f-news h6{white-space:nowrap;font-size:13px;font-weight:700;color:var(--ink);margin-bottom:10px}
.f-news form{display:flex;height:32px;border-radius:6px;overflow:hidden;background:var(--lilac)}
.f-news input{flex:1;min-width:0;border:0;background:transparent;padding:0 12px;font:400 13px 'Inter',sans-serif;color:var(--ink);outline:none}
.f-news input::placeholder{color:#0B1F44;opacity:.9}
.f-news button{width:32px;border:0;background:#5B21E0;color:#fff;display:grid;place-items:center;cursor:pointer;border-radius:6px;transition:background .2s}
.f-news button:hover{background:var(--purple)}
.f-news button svg{width:16px;height:16px}
.f-bot{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:16px;padding-top:30px;font-size:13px;color:#5B6478}
.f-legal{display:flex;align-items:center;flex-wrap:wrap}
.f-legal a{color:#5B6478;transition:color .2s}
.f-legal a:hover{color:var(--purple)}
.f-legal .sep{width:1px;height:14px;background:#5B6478;margin:0 24px}
@media(max-width:1100px){.f-top{grid-template-columns:minmax(0,1fr) repeat(4,minmax(0,160px));column-gap:28px}}
@media(max-width:960px){footer{padding:56px 0 32px}.f-top{grid-template-columns:repeat(4,minmax(0,1fr));column-gap:24px}.f-brand{grid-column:1/-1}}
@media(max-width:640px){.f-top{grid-template-columns:repeat(2,minmax(0,1fr));row-gap:32px}.f-col-company{display:contents}.f-col-company .f-news{grid-column:1/-1;max-width:none;margin-top:0}}
@media(max-width:480px){footer{padding:48px 0 28px}.f-bot{flex-direction:column;align-items:flex-start;gap:14px}.f-legal .sep{margin:0 14px}}

/* Keep the About composition balanced as the columns collapse. */
@media(max-width:960px){
  .about-page .hero{padding:130px 0 72px}
  .about-page .hero-grid{gap:48px}
  .about-page .orbit-wrap{max-width:320px}
}
@media(max-width:600px){
  .about-page{--pad:64px}
  .about-page .wrap{padding-inline:20px}
  .about-page h1{font-size:clamp(34px,9vw,44px)}
  .about-page h2{font-size:clamp(28px,7vw,36px)}
  .about-page .hero{padding:108px 0 64px}
  .about-page .hero h1{margin-top:14px}
  .about-page .hero .btn{margin-top:26px}
  .about-page .pills{margin-top:30px;gap:8px}
  .about-page .pill{font-size:12px;padding:8px 12px}
  .about-page .orbit-wrap{width:min(calc(100% - 100px),260px)}
  .about-page .purpose,.about-page .serve{margin-inline:10px;border-radius:28px}
  .about-page .philo{margin:64px 10px 0;border-radius:28px}
  .about-page .sec-head{margin-bottom:40px}
  .about-page .flow{row-gap:36px}
  .about-page .node .bubble{width:82px;height:82px;margin-bottom:18px}
  .about-page .ap{padding:30px 24px}
  .about-page .who{padding:22px 18px}
  .about-page .who .ic{width:44px;height:44px}
  .about-page .pp{padding:28px 24px}
  .about-page .philo-grid{margin-top:40px}
  .about-page .tagline{margin-top:40px}
  .about-page .cta-inner{padding:56px 22px;border-radius:28px}
  .about-page .cta-inner .btn{margin-top:28px}
}
@media(max-width:390px){
  .about-page .hero-grid{gap:36px}
  .about-page .orbit-wrap{width:min(calc(100% - 110px),230px)}
  .about-page .who{gap:12px}
  .about-page .who h3{font-size:18px}
}

@media (prefers-reduced-motion:reduce){
  *,*::before,*::after{animation:none!important;transition:none!important}
  .rv,.stagger>*,.fade-in{opacity:1!important;transform:none!important}
  .reveal-text span{color:var(--ink)!important}
}

`;

const ABOUT_RESPONSIVE_STYLES = `
/* Content-only responsive refinements; shared header/footer remain unchanged. */
@media (min-width: 901px){
  .about-page{--pad:clamp(68px,7vw,96px)}
  .about-page .hero{padding-bottom:clamp(66px,6vw,86px)}
  .about-page .sec-head{margin-bottom:clamp(38px,4vw,54px)}
}
@media (max-width: 600px){
  .about-page{--pad:52px}
  .about-page .wrap{padding-left:20px;padding-right:20px}
  .about-page section{padding-top:var(--pad);padding-bottom:var(--pad)}
  .about-page .hero{padding:104px 0 52px}
  .about-page h1{font-size:clamp(31px,8.5vw,37px)}
  .about-page h2{font-size:clamp(26px,7.2vw,31px);margin-top:13px}
  .about-page h3{font-size:18px}
  .about-page .lead{font-size:15px;line-height:1.6;margin-top:15px}
  .about-page .btn{height:auto;min-height:46px;padding:10px 18px;font-size:14px;white-space:normal;text-align:center}
  .about-page .pills{margin-top:28px;gap:8px}
  .about-page .pill{font-size:12px;padding:8px 11px}
  .about-page .pill svg{width:14px;height:14px}
  .about-page .orbit-wrap,.about-page .orbit-wrap .ring,.about-page .orbit-wrap .glow,.about-page .spinner{display:none}
  .about-page .hero-grid{gap:0}
  .about-page .purpose,.about-page .serve,.about-page .philo{border-radius:24px;margin-left:8px;margin-right:8px}
  .about-page .reveal-text{font-size:18px;line-height:1.55}
  .about-page .ic{width:44px;height:44px;border-radius:13px}
  .about-page .ic svg{width:21px;height:21px}
  .about-page .node .bubble{width:72px;height:72px;margin-bottom:18px}
  .about-page .node .bubble svg{width:27px;height:27px}
  .about-page .ap{padding:28px 22px 30px}
  .about-page .ap .ic{margin-bottom:20px}
  .about-page .who{padding:22px 18px;gap:14px}
  .about-page .who .go{display:none}
  .about-page .philo-grid{margin-top:34px;gap:14px}
  .about-page .pp{padding:25px 21px}
  .about-page .cta-inner{padding:48px 20px;border-radius:24px}
  .about-page .cta-inner .ring{display:none}
}
@media (min-width:601px) and (max-width:720px){
  .about-page{--pad:60px}
  .about-page .hero{padding:118px 0 60px}
  .about-page h1{font-size:42px}
  .about-page h2{font-size:34px}
  .about-page .lead{font-size:16px}
  .about-page .btn{min-height:48px;height:auto;font-size:14px;padding:11px 19px}
  .about-page .orbit-wrap,.about-page .orbit-wrap .ring,.about-page .orbit-wrap .glow,.about-page .spinner{display:none}
  .about-page .hero-grid{gap:0}
  .about-page .purpose,.about-page .serve,.about-page .philo{border-radius:28px;margin-inline:10px}
  .about-page .ic{width:48px;height:48px}
  .about-page .ap{padding:30px 24px}
  .about-page .cta-inner .ring{display:none}
}
`;

const CheckIcon = () => (
  <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

const ArrowIcon = () => <span className="arr">→</span>;

export default function About() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          observer.unobserve(entry.target);
        }
      }),
      { threshold: 0.18, rootMargin: "0px 0px -60px 0px" }
    );

    document.querySelectorAll(".about-page .rv, .about-page .stagger").forEach((el) => observer.observe(el));

    const cards = document.querySelectorAll(".about-page .ap");
    const moveHandlers = new Map();
    cards.forEach((card) => {
      const handler = (event) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty("--mx", `${event.clientX - rect.left}px`);
        card.style.setProperty("--my", `${event.clientY - rect.top}px`);
      };
      moveHandlers.set(card, handler);
      card.addEventListener("pointermove", handler);
    });

    const revealText = document.getElementById("about-reveal-text");
    const words = revealText
      ? revealText.textContent.trim().split(/\s+/).map((word, index) => (
          <span key={index}>{word}</span>
        ))
      : [];

    if (revealText) {
      // Render the words imperatively so the reference's scroll-linked effect stays lightweight.
      revealText.innerHTML = "";
      words.forEach((word, index) => {
        const span = document.createElement("span");
        span.textContent = word.props.children;
        if (index < 0) span.classList.add("on");
        revealText.appendChild(span);
        if (index < words.length - 1) revealText.appendChild(document.createTextNode(" "));
      });
    }

    const paint = () => {
      if (!revealText) return;
      const spans = [...revealText.querySelectorAll("span")];
      const rect = revealText.getBoundingClientRect();
      const vh = window.innerHeight;
      const start = vh * 0.85;
      const end = vh * 0.45;
      const progress = Math.min(1, Math.max(0, (start - rect.top) / ((start - end) + rect.height)));
      const active = Math.round(progress * spans.length);
      spans.forEach((span, index) => span.classList.toggle("on", reduce || index < active));
    };

    if (reduce) paint();
    else {
      window.addEventListener("scroll", paint, { passive: true });
      window.addEventListener("resize", paint);
      paint();
    }

    return () => {
      observer.disconnect();
      cards.forEach((card) => card.removeEventListener("pointermove", moveHandlers.get(card)));
      if (!reduce) {
        window.removeEventListener("scroll", paint);
        window.removeEventListener("resize", paint);
      }
    };
  }, []);

  return (
    <>
      <style>{ABOUT_PAGE_STYLES + ABOUT_RESPONSIVE_STYLES}</style>
      <main className="about-page">
        <section className="hero">
          <div className="wrap hero-grid">
            <div>
              <span className="eyebrow fade-in" style={{ animationDelay: ".1s" }}>About Viriqo Hires</span>
              <h1 className="fade-in" style={{ animationDelay: ".25s" }}>
                Building a smarter way to hire <span className="grad">technical talent</span>
              </h1>
              <p className="lead fade-in" style={{ animationDelay: ".45s" }}>
              Viriqo Hires brings AI-powered interviews, technical assessments, candidate monitoring, and structured evaluation into one platform.
              </p>
              <a className="btn btn-primary fade-in" href="#what-we-are-building">See Viriqo Hires in Action <ArrowIcon /></a>
              <div className="pills fade-in" style={{ animationDelay: ".8s" }}>
                <span className="pill"><CheckIcon />Structured Hiring Process</span>
                <span className="pill"><CheckIcon />Fairer Evaluations</span>
                <span className="pill"><CheckIcon />Better Hiring Decisions</span>
              </div>
            </div>

            <div className="fade-in" style={{ animationDelay: ".5s" }}>
              <div className="orbit-wrap" aria-hidden="true">
                <div className="ring r1" /><div className="ring r2" /><div className="glow" />
                <div className="mark"><img src={heroMark} alt="" /></div>
                <div className="spinner">
                  {[["50%","0%","Interview"],["100%","50%","Assess"],["50%","100%","Verify"],["0%","50%","Evaluate"]].map(([left, top, label]) => (
                    <div className="chip" style={{ left, top }} key={label}><span><i />{label}</span></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="purpose">
          <div className="wrap purpose-grid">
            <div className="rv"><span className="eyebrow">Our Purpose</span><h2>Making technical hiring more structured</h2></div>
            <div>
              <p className="reveal-text" id="about-reveal-text">Technical hiring involves more than asking the right questions. Teams need a consistent way to assess skills, monitor remote interviews, evaluate candidates, and review the evidence behind hiring decisions.</p>
              <div className="note rv">
                <span className="ic"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M4 12h4l3-8 4 16 3-8h2" /></svg></span>
                Viriqo Hires brings the technical hiring process together in one workflow.
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="wrap" id="what-we-are-building">
            <div className="sec-head center rv"><span className="eyebrow">What We're Building</span><h2>One platform for the technical hiring journey</h2><p className="lead">From interview to evaluation, everything works together.</p></div>
            <div className="flow stagger">
              <div className="track"><b /><i /></div>
              <div className="node"><div className="bubble"><em>01</em><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z" /><path d="M9 11h.01M12 11h.01M15 11h.01" /></svg></div><h3>Interview</h3><p>AI-powered technical interviews with intelligent follow-up questions.</p></div>
              <div className="node"><div className="bubble"><em>02</em><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M8 7l-5 5 5 5M16 7l5 5-5 5M14 4l-4 16" /></svg></div><h3>Assess</h3><p>Real-time coding assessments and technical evaluation.</p></div>
              <div className="node"><div className="bubble"><em>03</em><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6z" /><circle cx="12" cy="11" r="2.5" /></svg></div><h3>Verify</h3><p>Screen, webcam, second-camera and AI-powered proctoring capabilities.</p></div>
              <div className="node"><div className="bubble"><em>04</em><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" /></svg></div><h3>Evaluate</h3><p>Structured scoring, benchmarks, notes, recordings and reports.</p></div>
            </div>
            <div className="callout rv"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" /><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" /></svg>One connected workflow. One place to review the interview.</div>
          </div>
        </section>

        <section className="approach">
          <div className="wrap">
            <div className="sec-head rv"><span className="eyebrow">Our Approach</span><h2>Built around what technical hiring teams need</h2></div>
            <div className="ap-grid stagger">
              <div className="ap"><span className="big">01</span><div className="ic"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M4 6h16M4 12h16M4 18h10" /></svg></div><h3>Consistency</h3><p>Define role-specific skills, questions, weightings, and evaluation criteria.</p></div>
              <div className="ap"><span className="big">02</span><div className="ic"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6z" /><path d="M9 12l2 2 4-4" /></svg></div><h3>Integrity</h3><p>Bring greater visibility to the candidate's interview environment through monitoring and proctoring.</p></div>
              <div className="ap"><span className="big">03</span><div className="ic"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><path d="M14 3v6h6M8 13h8M8 17h5" /></svg></div><h3>Evidence</h3><p>Keep evaluations, notes, recordings, flagged activity, and reports available for review.</p></div>
            </div>
          </div>
        </section>

        <section className="serve">
          <div className="wrap serve-grid">
            <div className="sec-head rv"><span className="eyebrow">Who We Serve</span><h2>Built for teams hiring technical talent</h2></div>
            <div className="stagger">
              <div className="who"><span className="ic"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 7M18.5 14a6.5 6.5 0 0 1 3 6" /></svg></span><div><h3>Talent Acquisition Teams</h3><p>Structure and manage technical interview workflows.</p></div><span className="go">→</span></div>
              <div className="who"><span className="ic"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="13" rx="2" width="18" x="3" y="7" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 13h18" /></svg></span><div><h3>Hiring Managers</h3><p>Review consistent, role-specific candidate evaluations.</p></div><span className="go">→</span></div>
              <div className="who"><span className="ic"><svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" viewBox="0 0 24 24"><rect height="16" rx="2" width="20" x="2" y="4" /><path d="M7 10l3 2-3 2M12 15h5" /></svg></span><div><h3>Engineering Teams</h3><p>Assess technical knowledge and coding skills.</p></div><span className="go">→</span></div>
            </div>
          </div>
        </section>

        <section className="philo">
          <div className="wrap">
            <div className="rv"><span className="eyebrow">Our Product Philosophy</span><h2>Make technical hiring more structured, verifiable, and actionable.</h2></div>
            <div className="philo-grid stagger">
              <div className="pp"><div className="k">Structured</div><div className="bar"><b /></div><p>Define what the role requires before the interview.</p></div>
              <div className="pp"><div className="k">Verifiable</div><div className="bar"><b /></div><p>Capture interview activity and supporting evidence for review.</p></div>
              <div className="pp"><div className="k">Actionable</div><div className="bar"><b /></div><p>Turn interview performance into structured evaluations.</p></div>
            </div>
          </div>
          <div className="tagline" aria-label="Better Interviews. Stronger Teams.">
            <div className="t" aria-hidden="true">
              {Array.from({ length: 4 }).map((_, i) => <React.Fragment key={i}><span>Better Interviews.</span><span className="dot">●</span><span>Stronger Teams.</span><span className="dot">●</span></React.Fragment>)}
            </div>
          </div>
        </section>

        <section id="cta">
          <div className="wrap">
            <div className="cta-inner rv">
              <span className="ring r1" /><span className="ring r2" />
              <div className="wrapc">
                <span className="eyebrow">See Viriqo Hires in Action</span>
                <h2>See what Viriqo Hires can do for your hiring team</h2>
                <p className="lead">Explore how AI-powered interviewing, assessment, monitoring, and evaluation come together in one platform.</p>
                <a className="btn btn-primary" href="#" onClick={(event) => { event.preventDefault(); openDemoModal(); }}>Book a Demo <ArrowIcon /></a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <CookieBanner />
    </>
  );
}
